module.exports = __webpack_public_path__ + "static/media/skeleton_bow.2784e93a.png";